import React from 'react';
import { styled } from 'linaria/react'
import { theme } from '../../Theme';

const ProductPageDetailSkeletonContainer = styled.div`
    & > div {
        ${theme.below.md} {
            margin: 0;
        }
    }

    .product-title-skeleton {
        height: 2rem;
    }

    .product-stock-tag {
        border-radius: 50px; 
    }

    .width-1 {
        width: 75px;
    }

    .width-2 {
        width: 150px;
    }

    .width-3 {
        width: 30px;
    }

    .button-tag {
        border-radius: 50px;
        color: #7d7d7d;
        white-space: nowrap;
    }

    .button-tag--active {
        background-color: rgb(var(--color-vb-gray-3));
        transition: background-color 0.5s ease;
    }
`

const ProductPageDetailSkeleton = ({className, ...props}) => {
   return (
      <ProductPageDetailSkeletonContainer className={`w-100 ${className ?? ""}`} {...props}>
        <div className='ml-64 h-100'>
            <div className="d-flex justify-content-between">
                <div className="placeholder placeholder-wave w-25"></div>
                <div className="placeholder placeholder-wave w-25"></div>
            </div>
            <div className="placeholder placeholder-wave w-100 mt-3 product-title-skeleton"></div>
            <div className="placeholder placeholder-wave w-50 mt-3" style={{height: '2rem'}}></div>
            <div className='d-flex gap-2'>
                <button className="button-tag button-tag--active py-8 mt-4"><span className="placeholder placeholder-wave width-1"></span></button>
                <button className="button-tag button-tag--active py-8 mt-4"><span className="placeholder placeholder-wave width-2"></span></button>
                <button className="button-tag button-tag--active py-8 mt-4"><span className="placeholder placeholder-wave width-3"></span></button>
            </div>
            <div className="placeholder placeholder-wave w-50 my-3 product-stock-tag" style={{height: '0.75rem'}}></div>
        </div>
      </ProductPageDetailSkeletonContainer>
   )
}

export default ProductPageDetailSkeleton